import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "locations",
        "insuranceType",
        "insurerIdContainer",
        "insurerId",
        "locationPlanIdContainer",
        "locationPlanId",
        "button"
    ]

    connect() {
        this.refresh();
    }

    insurerChanged() {
        // Update the location plan picker to only show options associated with this insurer.
        // To do this, we update the location_id in the URL used for the insurer picker.
        const locationPlanPicker = $(this.locationPlanIdTarget).closest('[data-controller=autocomplete]');
        const oldUrl = locationPlanPicker.attr('data-autocomplete-url-value');
        const newUrl = oldUrl.substring(0, oldUrl.lastIndexOf('=')) + '=' + this.insurerIdTarget.value;
        locationPlanPicker.attr('data-autocomplete-url-value', newUrl);
    
        // Clear the current value from the location plan picker to force the user to choose again.
        this.locationPlanIdTarget.value = '';
        const locationPlanInput = locationPlanPicker.find('input[type=text]');
        locationPlanInput.val('');
      
        this.refresh();
      }
    
    refresh() {
        // The user must answer the first question about the type of insurance they have
        const insuranceType = this.insuranceTypeTarget.value;
        if (insuranceType == "") {
            this.insurerIdContainerTarget.classList.add("hidden");
            this.locationPlanIdContainerTarget.classList.add("hidden");
            this.buttonTarget.disabled = true;
            return;
        }

        // If they don't have insurance, they can go on.
        if (insuranceType == "no") {
            this.insurerIdContainerTarget.classList.add("hidden");
            this.locationPlanIdContainerTarget.classList.add("hidden");
            this.buttonTarget.disabled = false;
            return;
        }

        // If the location they picked is not fully supported (meaning we don't have pricing data), then skip the rest of the questions.
        const selectedLocationId = this.locationsTarget.getAttribute("data-selected-location-id");
        const supportedLocationIds = this.locationsTarget.getAttribute("data-supported-location-ids").split(',');
        if (supportedLocationIds.indexOf(selectedLocationId) == -1) {
            this.insurerIdContainerTarget.classList.add("hidden");
            this.locationPlanIdContainerTarget.classList.add("hidden");
            this.buttonTarget.disabled = false;
            return;
        }

        // Reveal the insurer picker.
        this.insurerIdContainerTarget.classList.remove("hidden");
        const insurerId = this.insurerIdTarget.value;

        // If they have some sort of insurance, they need to specify who's the insurer.
        if (insurerId == "") {
            this.locationPlanIdContainerTarget.classList.add("hidden");
            this.buttonTarget.disabled = true;
            return;
        }

        // Reveal the plan picker
        this.locationPlanIdContainerTarget.classList.remove("hidden");
        const locationPlanId = this.locationPlanIdTarget.value;

        // After they pick they insurer, they also need to pick the plan.
        if (locationPlanId == "") {
            this.buttonTarget.disabled = true;
            return;
        }

        this.buttonTarget.disabled = false;
    }
}